export const regionsOperateOptions: string[] = [
    'Australia Asia',
    'Europe',
    'LatAm',
    'MEA (Middle East Africa)',
    'North America',
];
